// extracted by mini-css-extract-plugin
module.exports = {"summaryTable":"checkout_summaryTable__1mrPU","total":"checkout_total__3iViq","shippingMethod":"checkout_shippingMethod__30JLw"};